import Vue from 'vue'
import Vuex from 'vuex'

import { auth } from './modules/auth'
import { route } from './modules/route'
import { loader } from './modules/loader'
import { aiAgent } from './modules/aiagent'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    route,
    loader,
    aiAgent
  }
})

export default store
